import { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PlayButton from '../../shared/PlayButton';
import ImageWithDefault from '../../../shared/ImageWithDefault';
import Default from '../../list/childPresentations/Default';
import commonCss from '../../../../styles/common.module.scss';
import { defaultBrickImageSrc } from '../../../../constants/imageUrls';
import css from './brickTile.module.scss';

const BrickTile = ({
  guideItem,
  getStyles,
  isLandscapeImage,
  index,
  isExtendedInfoEnabled,
}) => {
  const bannerImgSrc = isLandscapeImage
    ? get(guideItem, 'properties.landscapeImage.imageUrl')
    : get(guideItem, 'properties.brickImage.imageUrl');

  return (
    <Fragment>
      <div data-testid="brickTileOverlay" className={commonCss.overlay}>
        <div
          className={css.container}
          data-testid={`guideItem-${index}`}
          data-testtype="brickTile"
        >
          <PlayButton guideItem={guideItem}>
            <ImageWithDefault
              dataTestId="guideItemImage"
              src={bannerImgSrc || defaultBrickImageSrc}
              placeholder={defaultBrickImageSrc}
              alt={guideItem.title}
              className={css.image}
            />
          </PlayButton>
        </div>
      </div>
      {isExtendedInfoEnabled && (
        <div className={css.container} data-testid="extendedInfo">
          <Default
            guideItem={guideItem}
            getStyles={getStyles}
            index={0}
            containerClassName={css.guideItemContainer}
            imageWrapperClassName={css.guideItemImageWrapper}
          />
        </div>
      )}
    </Fragment>
  );
};

BrickTile.propTypes = {
  guideItem: PropTypes.object.isRequired,
  getStyles: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isLandscapeImage: PropTypes.bool,
  isExtendedInfoEnabled: PropTypes.bool,
};

export default BrickTile;
